import React, { Component } from "react";
import MainLayout from "../../components/layouts/MainLayout";
import { withRouter } from "../../hoc/withRouter";
import { Button, DatePicker, Form, Input, message, Modal, Select, Table, Tag, Tooltip } from "antd";
import { orderService } from "../../services/otodisApi/OrderService";
import { MonitoringOrderStates } from "./types/MonitoringOrderTypes";
import { CloudSyncOutlined, CopyOutlined } from "@ant-design/icons";
import withAuth from "../../hoc/withAuth";
import moment from "moment";
import ModalDetailOrder from "../../components/order/ModalDetailOrder";

export interface HomeProps {}

class MonitoringOrder extends Component<HomeProps & any, MonitoringOrderStates> {
  private readonly initState!: MonitoringOrderStates;
  private tableColumn: any = [
    {
      title: "Kode Order  | Kode Offer",
      dataIndex: "order_code",
      // width: 200,
      render: (value: string, row: any) => {
        return (
          <React.Fragment>
            <span className={`font-90-link`} onClick={(event) => this.showDetail(row)}>
              {value}
            </span>{" "}
            <Tooltip title="Click untuk copy kode stock unit" color={"cyan"}>
              <CopyOutlined className={"small-avatar-link"} onClick={(event) => this.copyToClipboard(value)} />
            </Tooltip>{" "}
            <br /> <span className={`font-90-link`}>{row.amh_order_number}</span>
            &nbsp; &nbsp;
            <Tooltip title="Click untuk copy kode stock unit" color={"cyan"}>
              <CopyOutlined className={"small-avatar-link"} onClick={(event) => this.copyToClipboard(row.amh_order_number)} />
            </Tooltip>
          </React.Fragment>
        );
      },
    },
    {
      title: "Tgl Order",
      dataIndex: "order_create_date",
      // width: 80,
      render: (value: string, row: any) => {
        const date = moment(value).format("YYYY-MM-DD");
        return date;
      },
    },
    {
      title: "Nomor Mesin",
      dataIndex: "vehicle_engine_number",
      // width: 100,
      render: (value: string, row: any) => {
        const showInNosin = row?.stock_condition === "SECOND" ? row?.vehicle_license_plate + " - " + row?.vehicle_engine_number : row?.vehicle_engine_number;
        return (
          <React.Fragment>
            <span className={`font-90-link`}>{showInNosin}</span>
            &nbsp; &nbsp;
            <Tooltip title="Click untuk copy kode stock unit" color={"cyan"}>
              <CopyOutlined className={"small-avatar-link"} onClick={(event) => this.copyToClipboard(showInNosin)} />
            </Tooltip>
            <br />
            <span style={{ fontSize: "70%", fontStyle: "italic" }}>{row?.vehicle_fixed_purchase_price <= 0 ? <span className={`font-90-link`}>{"BELUM HK"}</span> : <span>{"SUDAH HK"}</span>}</span>
          </React.Fragment>
        );
      },
    },
    {
      title: "Nama Konsumen",
      dataIndex: "customer_name",
      // width: 80,
      render: (value: string, row: any) => {
        return (
          <React.Fragment>
            <span>{value}</span>
            <br />
            <span style={{ fontSize: "70%", fontStyle: "italic" }}>
              {row.customer_type !== "" && row.customer_type !== "INDIVIDUAL" ? <span className={`font-90-link`}>{row.customer_type}</span> : <span>{row.customer_type}</span>}
            </span>
          </React.Fragment>
        );
      },
    },
    {
      title: "Detail Pengiriman",
      dataIndex: "order_delivery_number",
      // width: 150,
      render: (value: string, row: any) => {
        return (
          <React.Fragment>
            {value ? (
              <span>
                <span className={`font-90-link`}>{value}</span>{" "}
                <Tooltip title="Click untuk copy kode stock unit" color={"cyan"}>
                  <CopyOutlined className={"small-avatar-link"} onClick={(event) => this.copyToClipboard(value)} />
                </Tooltip>
                <br /> {row.order_delivery_date}
              </span>
            ) : (
              <span>-</span>
            )}
          </React.Fragment>
        );
      },
    },
    {
      title: "Tgl Handover",
      dataIndex: "handover_delivery_date",
      width: 120,
      render: (value: string, row: any) => {
        return (
          <React.Fragment>
            <span style={{ fontSize: "80%" }}>{`${row.order_create_date}`}</span>
          </React.Fragment>
        );
      },
    },
    {
      title: "Handover Detail",
      dataIndex: "handover_deliver_detail",
      width: 120,
      render: (value: any, row: any) => {
        // console.log(value);

        return (
          <React.Fragment>
            {value?.receiver_name && value?.receiver_signature_url && (
              <span className={`font-90-link`} onClick={() => this.configModalImage(true, value?.receiver_signature_url)} style={{ cursor: "pointer", maxWidth: "100px" }}>
                {value?.receiver_name}
              </span>
            )}
            <br />
            {value?.handover_proof_url && (
              <span className={`font-90-link`} onClick={() => this.configModalImage(true, value?.handover_proof_url)} style={{ cursor: "pointer", maxWidth: "100px" }}>
                Bukti Serah
              </span>
            )}
          </React.Fragment>
        );
      },
    },
    {
      title: "Status Order",
      dataIndex: "order_status",
      // width: 50,
    },
    {
      title: "Status BBN",
      dataIndex: "transfer_title_status",
      // width: 50,
    },
    {
      title: "Biro Jasa",
      dataIndex: "service_bureau_name",
      // width: 80,
      render: (value: string, row: any) => {
        const dataBbn = row.transfer_title_status && row.transfer_title_status !== "NONE" && row.transfer_title_status !== "PENDING" ? `${value} - ${row.service_bureau_code}` : "-";
        return (
          <React.Fragment>
            <span>{dataBbn}</span>
          </React.Fragment>
        );
      },
    },
    {
      title: "Metode Beli",
      dataIndex: "order_payment_method",
      // width: 40,
      render: (value: string) => {
        return value === "CREDIT" ? <Tag color="success">CREDIT</Tag> : <Tag color="geekblue">CASH</Tag>;
      },
    },
    {
      title: "Flag Leasing",
      dataIndex: "leasing_flag",
      // width: 50,
    },
    {
      title: "Status Vat",
      dataIndex: "order_vat_status",
      // width: 60,
    },
    {
      title: "Link Faktur",
      dataIndex: "order_vat_number",
      // width: 60,
      render: (value: string, row: any) => {
        return (
          <React.Fragment>
            {value !== "NONE" && value !== "" ? (
              <a href={value} target="_blank" rel="noopener noreferrer">
                LINK
              </a>
            ) : (
              <span>NONE</span>
            )}
          </React.Fragment>
        );
      },
    },
  ];

  constructor(props: (HomeProps & any) | any) {
    super(props);

    this.initState = {
      processing: false,
      processingFetchTableData: false,
      dataOrder: [],
      dealerCode: props.match.params.dealerCode.replace(/-/g, "#"),
      pageSize: 100,
      showModalDetailOrder: false,
      rowDetailOrder: [],
      filterOrder: "UNDELIVERED",
      filterVehicleEngineNumber: "",
      filterStartDate: moment().clone().startOf("month").format("YYYY-MM-DD"),
      filterEndDate: moment().clone().endOf("month").format("YYYY-MM-DD"),
      filterOrderCode: "",
      showModalUpdateOwner: false,
      showModalImage: false,
      modalImageUrl: "",
    };
    this.state = { ...this.initState };
  }

  copyToClipboard = async (data: any) => {
    await navigator.clipboard.writeText(data);
  };

  closeModalDetailOrder = (data: any) => {
    this.setState({
      showModalDetailOrder: false,
    });
  };

  showDetail = async (data: any) => {
    // console.log(data);
    await this.promisedSetState({
      rowDetailOrder: data,
      showModalDetailOrder: true,
    });
  };

  onDealerChange = async (data: any) => {
    await this.promisedSetState({
      processingFetchTableData: true,
      dealerCode: data.value,
    });
  };

  fetchOrderData = async () => {
    await this.promisedSetState({
      dataOrder: [],
      processingFetchTableData: true,
    });

    let params = {};
    if (this.state.filterOrderCode !== "") {
      params = {
        dealerCode: this.state.dealerCode,
        orderCode: this.state.filterOrderCode,
      };
    } else if (this.state.filterVehicleEngineNumber !== "") {
      params = {
        vehicleEngineNumber: this.state.filterVehicleEngineNumber,
      };
    } else {
      params = {
        dealerCode: this.state.dealerCode,
        dateStart: moment(this.state.filterStartDate).startOf("month").format("YYYY-MM-DD"),
        dateEnd: moment(this.state.filterStartDate).endOf("month").format("YYYY-MM-DD"),
        dataType: "create_date",
        statusOrder: this.state.filterOrder === "BELUM HANDOVER" ? "DELIVERED" : this.state.filterOrder,
        handoverStatus: this.state.filterOrder === "BELUM HANDOVER" ? "BELUM HANDOVER" : "",
      };
    }
    orderService
      .getOrderByStatus(params)
      .then(async (value) => {
        await this.promisedSetState({
          dataOrder: value.data.data,
          processingFetchTableData: false,
        });
      })
      .catch(async (reason) => {
        await this.promisedSetState({
          dataOrder: [],
          processingFetchTableData: false,
        });
        message.error("Data Tidak Ditemukan");
      });
  };

  onChangeTable = (pagination: any, filters: any, sorter: any) => {
    if (pagination?.pageSize) {
      this.setState({
        pageSize: pagination?.pageSize,
      });
    }
  };

  onFieldChange = <T extends keyof Pick<any, "filterStartDate" | "filterEndDate" | "filterOrder" | "filterOrderCode" | "filterVehicleEngineNumber">>(target: T, value: any) => {
    const currentState: any = { ...this.state };
    switch (target) {
      case "filterStartDate":
        currentState.filterStartDate = value;
        break;
      case "filterEndDate":
        currentState.filterEndDate = value;
        break;
      case "filterOrder":
        currentState.filterOrder = value;
        break;
      case "filterOrderCode":
        currentState.filterOrderCode = value;
        break;
      case "filterVehicleEngineNumber":
        currentState.filterVehicleEngineNumber = value;
        break;
    }
    this.setState({
      ...currentState,
    });
  };

  configModalImage = async (showModal: boolean, imgUrl: string) => {
    await this.promisedSetState({
      showModalImage: showModal,
      modalImageUrl: imgUrl,
    });
  };

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  render() {
    return (
      <React.Fragment>
        <MainLayout
          noPadNoMar={true}
          onChangeDealer={this.onDealerChange}
          breadcrumbPath={`Order`}
          breadcrumbMenu={`Monitoring Order`}
          defaultSelectedKeys={["m-monitoring-order"]}
          defaultOpenKeys={["sm-order"]}
        >
          <div style={{ padding: 20 }}>
            <Form layout={`inline`}>
              <Form.Item className={"padTop-10"} label="">
                <i className={`small-text-grey`}>Tanggal Order</i>
                <br />
                <DatePicker defaultValue={moment(this.state.filterStartDate, "YYYY-MM")} onChange={(event) => this.onFieldChange("filterStartDate", event)} format={"YYYY-MM"} picker="month" />
              </Form.Item>
              <Form.Item className={"padTop-10"} style={{ minWidth: 140 }}>
                <i className={`small-text-grey`}>Status</i>
                <Select showSearch placeholder="Pilih Metide" optionFilterProp="children" onChange={(value) => this.onFieldChange("filterOrder", value)} value={this.state.filterOrder}>
                  <Select.Option key={`UNDELIVERED`} value={`UNDELIVERED`}>{`Belum Dikirim`}</Select.Option>
                  <Select.Option key={`BELUM HANDOVER`} value={`BELUM HANDOVER`}>{`Belum Handover`}</Select.Option>
                  <Select.Option key={`UNASSIGNED`} value={`UNASSIGNED`}>{`Belum Penugasan`}</Select.Option>
                  <Select.Option key={`INVOICE_BBN_NOT_UPLOADED`} value={`INVOICE_BBN_NOT_UPLOADED`}>{`Belum Upload BBN`}</Select.Option>
                  <Select.Option key={`INVOICE_BBN_NOT_PAID`} value={`INVOICE_BBN_NOT_PAID`}>{`Belum Bayar BBN`}</Select.Option>
                  <Select.Option key={`UNFINISHED`} value={`UNFINISHED`}>{`Belum Final Sale`}</Select.Option>
                  <Select.Option key={`VAT_NOT_GENERATED`} value={`VAT_NOT_GENERATED`}>{`Belum Generate VAT`}</Select.Option>
                  <Select.Option key={`INVOICE_VAT_NOT_SCANNED`} value={`INVOICE_VAT_NOT_SCANNED`}>{`Belum Scan Faktur Pajak`}</Select.Option>
                  <Select.Option key={`BQ_NOT_SENT`} value={`BQ_NOT_SENT`}>{`Belum Kirim Data BQ`}</Select.Option>
                  <Select.Option key={`CANCELED`} value={`CANCELED`}>{`Batal`}</Select.Option>
                  <Select.Option key={`RETUR`} value={`RETUR`}>{`Retur`}</Select.Option>
                </Select>
              </Form.Item>

              <Form.Item className={"padTop-10"} style={{ minWidth: 120 }}>
                <i className={`small-text-grey`}>Kode Order</i>
                <Input value={this.state.filterOrderCode} onChange={(event) => this.onFieldChange("filterOrderCode", event.target.value)} placeholder="Kode Order" />
              </Form.Item>

              <Form.Item className={"padTop-10"} style={{ minWidth: 120 }}>
                <i className={`small-text-grey`}>Nomor Mesin</i>
                <Input value={this.state.filterVehicleEngineNumber} onChange={(event) => this.onFieldChange("filterVehicleEngineNumber", event.target.value)} placeholder="Nomor Mesin" />
              </Form.Item>

              <Form.Item className={"padTop-20"}>
                <Button onClick={this.fetchOrderData} type="primary" icon={<CloudSyncOutlined />}>
                  {" "}
                  Go{" "}
                </Button>
              </Form.Item>
            </Form>
            <span style={{ fontStyle: "italic", fontWeight: "bold", marginTop: 5, fontSize: "80%" }}>*) jika menggunakan pencarian Kode Order & Nomor Mesin akan mengabaikan filter lainnya</span>
          </div>
          <br />

          <Table
            rowKey={"order_code"}
            size={"small"}
            scroll={{ x: "calc(500px + 50%)" }}
            loading={this.state.processingFetchTableData}
            columns={this.tableColumn}
            dataSource={this.state.dataOrder}
            pagination={{ pageSize: this.state.pageSize }}
            onChange={this.onChangeTable}
          />

          <Modal visible={this.state.showModalImage} footer={null} onCancel={() => this.configModalImage(false, "")}>
            <img src={this.state.modalImageUrl} alt="Zoom" style={{ width: "100%" }} />
          </Modal>
          <ModalDetailOrder kodeOrder={"aaaa"} dataOrder={this.state.rowDetailOrder} visible={this.state.showModalDetailOrder} onClose={this.closeModalDetailOrder} />
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(MonitoringOrder), 46);
